import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { LoginModel, loginRequestData } from 'src/app/core/models/masters/login.model';
import { GlobalProperties } from 'src/app/global/global-properties';

@Injectable({
  providedIn: 'root'
})
export class LoginApiMasterService {
  // public currentUserSubject: BehaviorSubject<any>;
  // public currentUser: Observable<any>;
  constructor(private httpClient: HttpClient) {

    // sessionStorage.setItem('currentUser', JSON.stringify('1'));
    // this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(sessionStorage.getItem('currentUser')));
    // this.currentUser = this.currentUserSubject.asObservable();
  }
  //   public get currentUserValue(): UserProfileModel {
  //   return this.currentUserSubject.value;
  // }

  // this.http.get('assets/config.json').subscribe((data:any) => {
  
  //   sessionStorage.setItem('data-from-api', data['data-from-api'])
  //   if(data['data-from-api']==='true'){

  //   }
  //   else{
      
  //   }
  //  });

  public login(loginModel: LoginModel) {
    return lastValueFrom(this.httpClient.post(GlobalProperties.getSsoApiUrl + 'LoginService/UserLoginService', loginModel)
      .pipe(map((res: any) => res.responseData)));
  }

  public userlogin(loginModel: LoginModel) {
    return this.httpClient.post(GlobalProperties.getApiUrl + 'Security/SecurityUserLoginService', loginModel)
      .pipe(map((res: any) => res.responseData));
  }

  public readConfigDataFromApi(path:any) {
    return lastValueFrom(this.httpClient.get(path)
      .pipe(map((res: any) => res['data-from-api'])));
  }
   public readConfigSSOLogin(path:any) {
    return lastValueFrom(this.httpClient.get(path)
      .pipe(map((res: any) => res['loginWithSSO'])));
  }

   public readConfigsingleLoginForAllUser(path:any) {
    return lastValueFrom(this.httpClient.get(path)
      .pipe(map((res: any) => res['singleLoginForAllUser'])));
  }

  

  public reVerify(reVerifyModel:LoginModel) {
    return this.httpClient.post(GlobalProperties.getSsoApiUrl + 'ReVarification/RevarificationService', reVerifyModel);
  }

  public getMenuInfo(path:any) {
    return this.httpClient.get(path);
  }

}
